import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.GET_RULES_BEGIN](state) {
    state.rulesGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_RULES_SUCCESS](state, rules) {
    state.rulesGetError = null;
    state.rules = rules;
    state.rulesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_RULES_ERROR](state, err) {
    state.rulesGetState = API_STATES.REQUEST_ERROR;
    state.rulesGetError = err;
  }, 
  [types.CREATE_RULES_BEGIN](state) {
    state.ruleCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_RULES_SUCCESS](state) {
    state.ruleCreateError = null
    state.ruleCreateState = API_STATES.REQUEST_SUCCESS
  },
  [types.CREATE_RULES_ERROR](state, err) {
    state.ruleCreateState = API_STATES.REQUEST_ERROR;
    state.ruleCreateError = err;
  },
  [types.UPDATE_RULES_BEGIN](state) {
    state.ruleUpdateState = API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_RULES_SUCCESS](state) {
    state.ruleUpdateError = null
    state.ruleUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_RULES_ERROR](state, err) {
    state.ruleUpdateState = API_STATES.REQUEST_ERROR;
    state.ruleUpdateError = err;
  },
  [types.DELETE_RULES_BEGIN](state) {
    state.ruleDeleteState = API_STATES.REQUEST_PENDING
  },
  [types.DELETE_RULES_SUCCESS](state) {
    state.ruleDeleteError = null
    state.ruleDeleteState = API_STATES.REQUEST_SUCCESS
  },
  [types.DELETE_RULES_ERROR](state, err) {
    state.ruleDeleteState = API_STATES.REQUEST_ERROR;
    state.ruleDeleteError = err;
  },
};

export default mutations;
